import Invitation from "./Invitation";

export default Invitation;
